class Arkid3dModel {
    added = false;

    init() {
        Shopify.loadFeatures([
            {
              name: 'consent-tracking-api',
              version: '0.1',
              onLoad: this.registerEvents.bind(this),
            },
          ]);

       
    }

    registerEvents(errors) {
        if (errors) {
            console.error(errors);
        }

        if (window.Shopify?.customerPrivacy?.marketingAllowed()) {
            this.addIframe();
        }

        document.addEventListener('visitorConsentCollected', event => {
            if (event.detail.marketingAllowed) {
                this.addIframe();
            }
        });
    }


    addIframe() {
        if (!!this.added) {
            return;
        }

        this.added = true;
        const arModalElement = document.getElementById('arModal');
        if (arModalElement) {
            const iframe = document.createElement('iframe');
    
            const attributes = arModalElement.attributes;
            for (let i = 0; i < attributes.length; i++) {
                const attribute = attributes[i];
                iframe.setAttribute(attribute.name, attribute.value);
            }
    
            arModalElement.insertAdjacentElement("afterend",iframe) 
            arModalElement.remove();
        }
    }
    
}

(new Arkid3dModel).init();


